
import { defineComponent, reactive } from "vue";
import AppSpinner from "@/common/components/AppSpinner.vue";

const ButtonColor: { [key: string]: string } = {
  link: "bg-transparent text-current border-transparent hover:opacity-60 !rounded-none",
  black: "bg-black text-white border-black hover:opacity-80",
  white: "bg-background text-black hover:border-neutral-300",
};

const ButtonSize: (
  icon: boolean,
  dense: boolean
) => { [key: string]: string } = (icon, dense) => {
  if (icon) {
    return {
      xs: "w-6 h-6 text-xs",
      sm: "w-10 h-10 text-xs",
      md: "w-12 h-12 text-base",
      lg: "w-14 h-14 text-lg",
    };
  } else {
    return {
      xs: dense ? "p-1 space-x-1 text-xs" : "h-8 py-2 px-4 space-x-1 text-xs",
      sm: dense ? "p-2 space-x-1 text-xs" : "h-10 py-4 px-4 space-x-2 text-xs",
      md: dense
        ? "py-2 px-4 space-x-2 text-base"
        : "h-12 py-4 px-12 space-x-2 text-base",
      lg: dense
        ? "py-2 px-4 space-x-2 text-base"
        : "h-14 py-6 px-14 space-x-2 text-base",
    };
  }
};

export default defineComponent({
  components: { AppSpinner },
  emits: ["click"],
  props: {
    type: {
      type: String,
      default: "button",
    },
    color: {
      type: String,
      default: "black",
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "md",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    onlyIcon: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object || String,
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const classes = reactive([
      ButtonColor[props.color],
      ButtonSize(props.onlyIcon, props.dense)[props.size],
      props.fullWidth && "w-full",
      (props.loading || props.disabled) &&
        "active:scale-100 cursor-default hover:opacity-100 hover:border-2",
      props.rounded ? "rounded-full" : "rounded",
    ]);

    const is = !props.to ? (!props.href ? "button" : "a") : "router-link";

    return { classes, is, props };
  },
});
